import { apiSlice } from "../api/apiSlice";

export const teamsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeamsAll: builder.query({
      query: (userEmail) => {
        console.log(userEmail);
        return `/teams?assigns_like=${userEmail}`;
      },
    }),
    getTeams: builder.query({
      query: (email) => {
        return `/teams?q=${email}`;
      },
    }),
    getTeam: builder.query({
      query: (teamType) => {
        return `/teams?type=${teamType}`;
      },
    }),
    createTeam: builder.mutation({
      query: (data) => {
        return {
          url: "/teams",
          method: "POST",
          body: data,
        };
      },

      async onQueryStarted(arg, { queryFulfilled, dispatch, getState }) {
        const { email } = getState()?.auth?.user;
        try {
          const response = await queryFulfilled;
          console.log(response.data);

          dispatch(
            apiSlice.util.updateQueryData("getTeams", email, (draft) => {
              draft.unshift(response.data);
            })
          );
        } catch (error) {}
      },
    }),
    deleteTeam: builder.mutation({
      query: (id) => {
        return {
          url: `/teams/${id}`,
          method: "delete",
        };
      },

      async onQueryStarted(id, { queryFulfilled, dispatch, getState }) {
        const { user } = getState()?.auth;

        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getTeams", user?.email, (draft) => {
            const newDraft = draft.filter((team) => {
              if (team?.id != id) {
                return team;
              }
            });
            return newDraft;
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          patchResult.undo();
        }
      },
    }),
    updateTeam: builder.mutation({
      query: (data) => {
        return {
          url: `/teams/${data.id}`,
          method: "put",
          body: data,
        };
      },

      async onQueryStarted(data, { queryFulfilled, dispatch, getState }) {
        const { user } = getState()?.auth;

        console.log(data);
        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getTeams", user?.email, (draft) => {
            const team = draft.find((t) => t?.id == data?.id);
            if (team?.id) {
              team.title = data.title;
              team.type = data.type;

              team.color = data.color;
              team.createdAt = Date.now();
            }
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          patchResult.undo();
        }
      },
    }),

    teamExistChecker: builder.query({
      query: (value) => `/teams?type=${value}`,
    }),
  }),
});
export const { useGetTeamsQuery, useCreateTeamMutation, useGetTeamsAllQuery } =
  teamsApi;
